export default __webpack_public_path__ + "static/media/cloud-download.d4152234.svg";